import { createContext } from 'react';

interface NetworkContextValue {
	online: boolean;
}

export const NetworkContext = createContext<NetworkContextValue>({
	online: false
});
